import { ReactNode, useEffect } from 'react';

import { Journey } from 'Global/Journey/Types/Journey';
import useDeviceDetect from 'Hooks/useDeviceDetect';
import useQueryState from 'Hooks/useQueryState';
import { FreightTabDto } from 'Services/Api/_HumanWritten/BookingWizardDataService';
import { formatPriceDisplay } from 'Util/_HumanWritten/PriceFormattingUtils';
import { Button, Colors, Display } from 'Views/Components/Button/Button';
import { Flex } from 'Views/Components/Flex/Flex';
import { FreightBookingDetailState } from '../../BookingWizardData/FreightBookingWizardData';
import {
	BulkFreightDetailsFormActionCreators as Abracadabra,
	BulkFreightDetailsFormAction,
} from './BulkFreightDetailsFormState';
import { confirmDeleteFreightItem } from './Utils/confirmDeleteFreightItem';
import { handleFreightCalculationFetch } from './Utils/handleFreightCalculationFetch';

interface Props {
	freightElements: FreightTabDto;
	journey: Journey;
	userId: string;
	state: FreightBookingDetailState;
	dispatch: (action: BulkFreightDetailsFormAction) => void;
}

export default function ShipmentCardCollapsed({ freightElements, journey, userId, state, dispatch }: Props) {
	// const categoryLabel = useMemo(() => {
	// 	const match = freightElements.freightCategoryTypes.find(x => x.id === state.freightCategoryId);
	// 	return match?.label;
	// }, [state.freightCategoryId]);

	// const typeLabel = useMemo(() => {
	// 	const match = freightElements.freightTypes[state.freightCategoryId]?.find(x => x.id === state.freightTypeId);
	// 	return match?.label;
	// }, [state.freightCategoryId, state.freightTypeId]);

	const { state: freightCalculationRequest, query } = useQueryState(() =>
		handleFreightCalculationFetch({
			userId,
			journey,
			freightTypeId: state.freightTypeId,
			freightCategoryId: state.freightCategoryId,
			quantity: state.quantity,
			weight: state.weight,
			width: state.width,
			height: state.height,
			length: state.length,
		}),
	);

	useEffect(() => {
		query();
	}, [
		journey,
		userId,
		state.freightTypeId,
		state.freightCategoryId,
		state.quantity,
		state.weight,
		state.width,
		state.height,
		state.length,
	]);

	const handleDelete = async () => {
		if (await confirmDeleteFreightItem(state)) {
			dispatch(Abracadabra.deleteDetail(state.id));
		}
	};

	return (
		<div className="shipment-details__container booking-section-card">
			<CardAlignment>
				<div className="generic-col">
					<div className="generic-row">
						{Object.keys(state.errors).length > 0 && <span className="error-indicator" />}
						<h6 className="m-none">
							{state.description && <>{state.description}</>}
							{!state.description && <>-</>}
						</h6>
					</div>
					{freightCalculationRequest.status === 'success' && (
						<div className="generic-col gap-none">
							<h5 className="m-none">
								{formatPriceDisplay(freightCalculationRequest.data.totalPrice, false, true, false)}
							</h5>
							<p className="m-none">{freightCalculationRequest.data.calculation}</p>
						</div>
					)}
				</div>
				<Flex justify="space-between" gap="xs">
					<Button
						className="edit-passenger__button"
						colors={Colors.Red}
						display={Display.Text}
						onClick={handleDelete}
					>
						Delete
					</Button>
					<Button
						className="edit-passenger__button"
						colors={Colors.Primary}
						display={Display.Text}
						onClick={() => dispatch(Abracadabra.editDetail(state.id))}
					>
						Edit
					</Button>
				</Flex>
			</CardAlignment>
		</div>
	);
}

interface ChildrenProps {
	children: ReactNode;
}

function CardAlignment({ children }: ChildrenProps) {
	const { isIpad } = useDeviceDetect();

	if (isIpad) {
		return <div className="generic-col">{children}</div>;
	}

	return <div className="generic-row generic-row--between">{children}</div>;
}
